import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { IMPORT_STATES } from './importStates'

interface Props {
  calloutType: string
  validEmployeesCount: number
  closeBanner: (value: boolean) => void
}

const Callout = ({ calloutType, validEmployeesCount, closeBanner }: Props) => {
  const backgroundColor = calloutType === 'processing' ? 'viridian100' : 'lime200'
  const iconColor = calloutType === 'processing' ? 'viridian1000' : 'lime1000'
  const icon = calloutType === 'processing' ? 'spinner' : 'thumbs-up'
  const description = () => {
    if (calloutType === IMPORT_STATES.PROCESSING) {
      return i18n.t('payroll_integrations.incidences.datev_lauds.import.processing', {
        count: validEmployeesCount,
      })
    } else if (calloutType === IMPORT_STATES.PROCESSED) {
      return i18n.t('payroll_integrations.incidences.datev_lauds.import.processed', {
        count: validEmployeesCount,
      })
    }
  }

  function close() {
    closeBanner(false)
    return null
  }

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      background={backgroundColor}
      paddingX="s16"
      paddingY="s12"
      borderRadius={{ all: 'abs012' }}
    >
      <Box flexDirection="row" justifyContent="flexStart" alignItems="center">
        <Icon.Medium icon={icon} color={iconColor} />
        <Text size="100">{description()}</Text>
      </Box>
      <Box onClick={close}>
        <Text size="100" color="lime1000" weight="bold">
          X
        </Text>
      </Box>
    </Box>
  )
}

export default Callout
